













// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as Info from "@/info";

export default defineComponent({
	setup(){
		const details = computed(() => {
			return {
				name:Info.companyName,
				logo:Info.companyLogo,
				url:Info.companyURL,
			}
		});

		const content = computed(() => {
			return {
				title:`<span>Powered by </span><span class="font-weight-bold">${details.value.name}</span>`,
				link:`<span class="mdi mdi-open-in-new"></span> About`,
			};
		});

		return {
			details,
			content,
		};
	}
});
